<template>
    <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
            <FormRow :fieldNameArr="[$t('FORM_NO'), $t('RFQ_TYPE'), $t('VENDOR_CODE'), $t('PLANT_CODE')]">
                <Input v-model="quotation.formNo" slot="a" disabled />
                <Input v-model="rfqType" slot="b" disabled />
                <Input v-model="quotation.vendorCode" slot="c" disabled />
                <Input v-model="quotation.plant" slot="d" disabled />
            </FormRow>
            <FormRow :fieldNameArr="[$t('CURRENCY'), $t('DELTA_PN')]">
                <Input v-model="quotation.currency" slot="a" disabled />
                <Input v-model="quotation.deltaPart" slot="b" disabled />
            </FormRow>
            <FormRow v-if="toolingQuotationFileView" :fieldNameArr="[$t('SPEC_FILE')]">
            </FormRow>
            <Table v-if="toolingQuotationFileView" width="600" border :columns="fileSchemaList" :data="tooling.attachments">
                <template slot-scope="{ row }" slot="action">
                    <Button type="primary" shape="circle" icon="md-download"
                        @click="downloadToolingAttachment(row)"></Button>
                </template>
            </Table>
        </Feature>

        <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
            <FormRow v-show="quotation.comments != ''"
                :fieldNameArr="[$t('DELTA_BUYER_NAME'), $t('TARGET_PRICE'), $t('EMAIL'), $t('COMMENTS')]">
                <Input v-model="cpcAccountName" slot="a" disabled />
                <Input v-model="quotation.targetPrice" slot="b" disabled />
                <Input style="width: 800px" v-model="quotation.cpcAccountConstactEmail" slot="c" disabled />
                <Button icon="ios-create" slot="d" @click="openComments">{{ $t('COMMENTS') }}</Button>
            </FormRow>

            <FormRow v-show="quotation.comments == ''"
                :fieldNameArr="[$t('DELTA_BUYER_NAME'), $t('TARGET_PRICE'), $t('EMAIL')]">
                <Input v-model="cpcAccountName" slot="a" disabled />
                <Input v-model="quotation.targetPrice" slot="b" disabled />
                <Input style="width: 800px" v-model="quotation.cpcAccountConstactEmail" slot="c" disabled />
            </FormRow>

            <FormRow v-if="cpcToSupplierReferenceFilesExited" :fieldNameArr="[$t('REFERENCE_FILE')]">
            </FormRow>
            <FormRow v-if="cpcToSupplierReferenceFilesExited" :fieldNameArr="[$t('')]">
                <Table width="600" border :columns="fileSchemaList" :data="cpcToSupplierReferenceFiles" slot="a">
                    <template slot-scope="{ row }" slot="action">
                        <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
                    </template>
                </Table>
            </FormRow>
        </Feature>

        <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
            <FormRow :fieldNameArr="['*' + $t('YOUR_PRICE'), '/1 ' + quotation.unit]">
                <Input v-model="quotation.price" ref="yourPrice" slot="a" :disabled="!quotation.editable" />
            </FormRow>
            <FormRow v-if="supplierAttachmentExited" :fieldNameArr="['']">
                <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
                    <template slot-scope="{ row }" slot="action">
                        <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
                    </template>
                </Table>
            </FormRow>
        </Feature>

        <ToolingAttributes :toolingQuotationType="toolingQuotationType" :tooling="tooling"></ToolingAttributes>
        <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
            :title="$t('COMMENTS')">
            <froala :config="FloraEditorConfig" v-model="quotation.comments"></froala>
        </Modal>
    </div>
</template>
   
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { FloraEditorConfig } from "../../util/common"
import { FileSchemaList } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import { ToolingMaterial } from "@/util/tableTitle"
import FormRowTwo from '@/components/FormRowTwo'
import ToolingAttributes from "@/views/quotation/ToolingAttributes"

export default {
    name: "HistoryOtherCompoment",
    components: {
        PLMDocument,
        FormRowTwo,
        ToolingAttributes
    },
    props: {
        quotation: {
            type: Object,
            default: () => null,
        },
        tooling: {
            type: Object,
            default: () => null,
        },
        rfqType: {
            type: String,
            default: () => "",
        },
        plmQuotationDocuments: {
            type: Array,
            default: () => [],
        },
        cpcToSupplierReferenceFiles: {
            type: Array,
            default: () => [],
        },
        toolingQuotationType: {
            type: String,
            default: () => "",
        },
        showSupplierQuotationFiles: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            FloraEditorConfig: FloraEditorConfig(""),
            fileSchemaList: FileSchemaList(this),
            commentsModal: false,
            materialColumn: ToolingMaterial(this),
            moldColumn: [
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('MOLD_MATERIAL');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'material'
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('MOLD_RAW_MATERIAL_PRICE');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'rawMaterialPrice'
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('MOLD_PROCESSING_FEE');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'processingFee'
                }
            ],
            engineeringColumn: [
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('ENGINEERING_TL_QUANTITY');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'quantity'
                },
                {
                    renderHeader: (h, params) => {
                        var text = this.$t('ENGINEERING_WEIGHT');
                        return h('div', {
                            domProps: {
                                innerHTML: text
                            }
                        })
                    },
                    align: 'center',
                    key: 'weight'
                }
            ],
        }
    },
    methods: {
        ...mapGetters(["getModalSize"]),
        ...mapActions(["toggleLoading"]),
        downloadAttachment(row) {
            this.$downloadAttachment(this, row.uuid)
        },
        downloadToolingAttachment(row) {
            this.$downloadToolingAttachment(this, this.quotation.uuid, row.uuid)
        },
        openComments() {
            this.commentsModal = true
        },
    },
    computed: {
        modalSize() {
            return this.getModalSize()
        },
        toolingQuotationFileView() {
            return this.tooling.attachments && this.tooling.attachments.length > 0
        },
        cpcAccountName() {
            return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
        },
        cpcToSupplierReferenceFilesExited() {
            return this.cpcToSupplierReferenceFiles && this.cpcToSupplierReferenceFiles.length > 0
        },
        supplierAttachmentExited() {
            return this.showSupplierQuotationFiles && this.showSupplierQuotationFiles.length > 0
        },
    },
}
</script>
 
<style scoped></style>
   